import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes$1 from 'prop-types';
import classNames from 'classnames';
import CardAction from '@mshops-components-library/card-action';
import { PromotionTag } from '@mshops-components-library/common';
import { Image as Image$2 } from 'frontend-image';
var REACT_ELEMENT_TYPE$1;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE$1 || (REACT_ELEMENT_TYPE$1 = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE$1,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var defaultPriceShape = {
  currency_id: '',
  symbol: '',
  fraction: '',
  decimal_separator: '',
  cents: ''
};
var priceShape = PropTypes$1.shape({
  currency_id: PropTypes$1.string,
  symbol: PropTypes$1.string,
  fraction: PropTypes$1.string,
  decimal_separator: PropTypes$1.string,
  cents: PropTypes$1.string
});
({
  id: PropTypes$1.string.isRequired,
  image: PropTypes$1.shape({
    src: PropTypes$1.string.isRequired,
    src2x: PropTypes$1.string,
    size: PropTypes$1.number
  }).isRequired,
  title: PropTypes$1.string,
  url: PropTypes$1.string,
  condition: PropTypes$1.string,
  className: PropTypes$1.string,
  tracking: PropTypes$1.string,
  bookmarked: PropTypes$1.bool,
  installments: PropTypes$1.string,
  attributes: PropTypes$1.string,
  lazyLoad: PropTypes$1.oneOf(['on', 'off']),
  price: priceShape,
  shipping: PropTypes$1.shape({
    freeShipping: PropTypes$1.bool,
    text: PropTypes$1.string.isRequired
  }),
  brand: PropTypes$1.shape({
    url: PropTypes$1.string.isRequired,
    text: PropTypes$1.string.isRequired
  }),
  discount: PropTypes$1.shape({
    text: PropTypes$1.string,
    original_price: priceShape
  }),
  actions: PropTypes$1.arrayOf(PropTypes$1.shape({
    id: PropTypes$1.string.isRequired
  })),
  with_card_action: PropTypes$1.bool,
  card_action: PropTypes$1.shape({}),
  product_cart_info: PropTypes$1.shape({
    is_cart_eligible: PropTypes$1.bool.isRequired,
    checkout_target: PropTypes$1.string.isRequired,
    checkout_target_mobile: PropTypes$1.string.isRequired
  }),
  namespace: PropTypes$1.string,
  ftNewComponentsV2: PropTypes$1.bool,
  shippingTitle: PropTypes$1.string,
  addToCart: PropTypes$1.func,
  variations_qty: PropTypes$1.number.isRequired,
  purchase_min_quantity: PropTypes$1.number.isRequired,
  onClickCta: PropTypes$1.func,
  trackEvent: PropTypes$1.func,
  trackingData: PropTypes$1.shape({}),
  itemLink: PropTypes$1.string.isRequired,
  relevant: PropTypes$1.bool.isRequired,
  onlyWebCheckout: PropTypes$1.bool
});
var defaultProps$1 = {
  actions: [],
  shipping: null,
  title: null,
  url: null,
  condition: null,
  tracking: null,
  id: null,
  installments: null,
  attributes: null,
  price: defaultPriceShape,
  discount: {
    text: '',
    original_price: defaultPriceShape
  },
  className: '',
  bookmarked: false,
  currency_id: null,
  symbol: null,
  lazyLoad: 'on',
  with_card_action: false,
  card_action: {},
  namespace: 'ui-item',
  ftNewComponentsV2: false,
  shippingTitle: '',
  addToCart: null,
  onClickCta: null,
  trackEvent: null,
  trackingData: null,
  product_cart_info: {
    is_cart_eligible: true,
    checkout_target: '',
    checkout_target_mobile: ''
  },
  globalConfig: {
    card: {
      design: 'center-aligned'
    }
  },
  deviceType: 'desktop'
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function createCommonjsModule$1(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function (path, base) {
      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}
function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var OverloadYield = createCommonjsModule$1(function (module) {
  function _OverloadYield(e, d) {
    this.v = e, this.k = d;
  }
  module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regeneratorDefine = createCommonjsModule$1(function (module) {
  function _regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
      i({}, "", {});
    } catch (e) {
      i = 0;
    }
    module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
      if (r) i ? i(e, r, {
        value: n,
        enumerable: !t,
        configurable: !t,
        writable: !t
      }) : e[r] = n;else {
        var o = function o(r, n) {
          _regeneratorDefine(e, r, function (e) {
            return this._invoke(r, n, e);
          });
        };
        o("next", 0), o("throw", 1), o("return", 2);
      }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
  }
  module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regenerator$1 = createCommonjsModule$1(function (module) {
  function _regenerator() {
    var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
      var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
      return regeneratorDefine(u, "_invoke", function (r, n, o) {
        var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
            p: 0,
            n: 0,
            v: e,
            a: d,
            f: d.bind(e, 4),
            d: function d(t, r) {
              return i = t, c = 0, u = e, G.n = r, a;
            }
          };
        function d(r, n) {
          for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
            var o,
              i = p[t],
              d = G.p,
              l = i[2];
            r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
          }
          if (o || r > 1) return a;
          throw y = !0, n;
        }
        return function (o, p, l) {
          if (f > 1) throw TypeError("Generator is already running");
          for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
            i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
            try {
              if (f = 2, i) {
                if (c || (o = "next"), t = i[o]) {
                  if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                  if (!t.done) return t;
                  u = t.value, c < 2 && (c = 0);
                } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                i = e;
              } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
            } catch (t) {
              i = e, c = 1, u = t;
            } finally {
              f = 1;
            }
          }
          return {
            value: t,
            done: y
          };
        };
      }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
        return this;
      }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
      return this;
    }), regeneratorDefine(u, "toString", function () {
      return "[object Generator]";
    }), (module.exports = _regenerator = function _regenerator() {
      return {
        w: i,
        m: f
      };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
  }
  module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regeneratorAsyncIterator = createCommonjsModule$1(function (module) {
  function AsyncIterator(t, e) {
    function n(r, o, i, f) {
      try {
        var c = t[r](o),
          u = c.value;
        return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
          n("next", t, i, f);
        }, function (t) {
          n("throw", t, i, f);
        }) : e.resolve(u).then(function (t) {
          c.value = t, i(c);
        }, function (t) {
          return n("throw", t, i, f);
        });
      } catch (t) {
        f(t);
      }
    }
    var r;
    this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
      return this;
    })), regeneratorDefine(this, "_invoke", function (t, o, i) {
      function f() {
        return new e(function (e, r) {
          n(t, i, e, r);
        });
      }
      return r = r ? r.then(f, f) : f();
    }, !0);
  }
  module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regeneratorAsyncGen = createCommonjsModule$1(function (module) {
  function _regeneratorAsyncGen(r, e, t, o, n) {
    return new regeneratorAsyncIterator(regenerator$1().w(r, e, t, o), n || Promise);
  }
  module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regeneratorAsync = createCommonjsModule$1(function (module) {
  function _regeneratorAsync(n, e, r, t, o) {
    var a = regeneratorAsyncGen(n, e, r, t, o);
    return a.next().then(function (n) {
      return n.done ? n.value : a.next();
    });
  }
  module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regeneratorKeys = createCommonjsModule$1(function (module) {
  function _regeneratorKeys(e) {
    var n = Object(e),
      r = [];
    for (var t in n) r.unshift(t);
    return function e() {
      for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
      return e.done = !0, e;
    };
  }
  module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _typeof_1 = createCommonjsModule$1(function (module) {
  function _typeof(o) {
    "@babel/helpers - typeof";

    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regeneratorValues = createCommonjsModule$1(function (module) {
  var _typeof = _typeof_1["default"];
  function _regeneratorValues(e) {
    if (null != e) {
      var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
        r = 0;
      if (t) return t.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) return {
        next: function next() {
          return e && r >= e.length && (e = void 0), {
            value: e && e[r++],
            done: !e
          };
        }
      };
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var regeneratorRuntime$1 = createCommonjsModule$1(function (module) {
  function _regeneratorRuntime() {
    var r = regenerator$1(),
      e = r.m(_regeneratorRuntime),
      t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
      var e = "function" == typeof r && r.constructor;
      return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
      "throw": 1,
      "return": 2,
      "break": 3,
      "continue": 3
    };
    function a(r) {
      var e, t;
      return function (n) {
        e || (e = {
          stop: function stop() {
            return t(n.a, 2);
          },
          "catch": function _catch() {
            return n.v;
          },
          abrupt: function abrupt(r, e) {
            return t(n.a, o[r], e);
          },
          delegateYield: function delegateYield(r, o, a) {
            return e.resultName = o, t(n.d, regeneratorValues(r), a);
          },
          finish: function finish(r) {
            return t(n.f, r);
          }
        }, t = function t(r, _t, o) {
          n.p = e.prev, n.n = e.next;
          try {
            return r(_t, o);
          } finally {
            e.next = n.n;
          }
        }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
        try {
          return r.call(this, e);
        } finally {
          n.p = e.prev, n.n = e.next;
        }
      };
    }
    return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
      return {
        wrap: function wrap(e, t, n, o) {
          return r.w(a(e), t, n, o && o.reverse());
        },
        isGeneratorFunction: n,
        mark: r.m,
        awrap: function awrap(r, e) {
          return new OverloadYield(r, e);
        },
        AsyncIterator: regeneratorAsyncIterator,
        async: function async(r, e, t, o, u) {
          return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
        },
        keys: regeneratorKeys,
        values: regeneratorValues
      };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
  }
  module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var runtime = regeneratorRuntime$1();
var regenerator = runtime;
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
var goToAction = function goToAction(url) {
  window.location = url;
};
function Action(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    target = _ref.target;
  return /*#__PURE__*/_createRawReactElement("button", {
    className: "ui-item__action",
    onClick: onClick || function (e) {
      e.preventDefault();
      goToAction(target);
    }
  }, void 0, label);
}
Action.defaultProps = {
  onClick: null,
  target: null
};
var ItemImage$1 = function ItemImage(_ref) {
  var lazyLoad = _ref.lazyLoad,
    src = _ref.src,
    size = _ref.size,
    src2x = _ref.src2x,
    title = _ref.title;
  return /*#__PURE__*/_createRawReactElement("div", {
    className: "ui-item__image-container"
  }, void 0, /*#__PURE__*/_createRawReactElement("meta", {
    itemProp: "image",
    content: src
  }), /*#__PURE__*/_createRawReactElement(Image$2, {
    src: src,
    lazyload: lazyLoad,
    width: size,
    height: size,
    alt: title,
    srcSet: src2x ? "".concat(src, " 1x, ").concat(src2x, " 2x") : null,
    className: "ui-item__image"
  }));
};
ItemImage$1.defaultProps = {
  size: null,
  src2x: null,
  title: null,
  lazyLoad: 'on'
};
var Image$1 = ItemImage$1;
function _typeof(o) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function createCommonjsModule(fn, basedir, module) {
  return fn(module = {
    path: basedir,
    exports: {},
    require: function (path, base) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }(null == base && module.path);
    }
  }, module.exports), module.exports;
}
var b = "function" == typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === _typeof(a) && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var reactIs_production_min = {
    AsyncMode: l,
    ConcurrentMode: m,
    ContextConsumer: k,
    ContextProvider: h,
    Element: c,
    ForwardRef: n,
    Fragment: e,
    Lazy: t,
    Memo: r,
    Portal: d,
    Profiler: g,
    StrictMode: f,
    Suspense: p,
    isAsyncMode: function (a) {
      return A(a) || z(a) === l;
    },
    isConcurrentMode: A,
    isContextConsumer: function (a) {
      return z(a) === k;
    },
    isContextProvider: function (a) {
      return z(a) === h;
    },
    isElement: function (a) {
      return "object" === _typeof(a) && null !== a && a.$$typeof === c;
    },
    isForwardRef: function (a) {
      return z(a) === n;
    },
    isFragment: function (a) {
      return z(a) === e;
    },
    isLazy: function (a) {
      return z(a) === t;
    },
    isMemo: function (a) {
      return z(a) === r;
    },
    isPortal: function (a) {
      return z(a) === d;
    },
    isProfiler: function (a) {
      return z(a) === g;
    },
    isStrictMode: function (a) {
      return z(a) === f;
    },
    isSuspense: function (a) {
      return z(a) === p;
    },
    isValidElementType: function (a) {
      return "string" == typeof a || "function" == typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    },
    typeOf: z
  },
  reactIs_development = createCommonjsModule(function (module, exports) {
    "production" !== process.env.NODE_ENV && function () {
      var hasSymbol = "function" == typeof Symbol && Symbol.for,
        REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103,
        REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106,
        REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107,
        REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108,
        REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114,
        REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109,
        REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110,
        REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111,
        REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111,
        REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112,
        REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113,
        REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120,
        REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115,
        REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116,
        REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121,
        REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117,
        REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118,
        REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function typeOf(object) {
        if ("object" === _typeof(object) && null !== object) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE,
        ConcurrentMode = REACT_CONCURRENT_MODE_TYPE,
        ContextConsumer = REACT_CONTEXT_TYPE,
        ContextProvider = REACT_PROVIDER_TYPE,
        Element = REACT_ELEMENT_TYPE,
        ForwardRef = REACT_FORWARD_REF_TYPE,
        Fragment = REACT_FRAGMENT_TYPE,
        Lazy = REACT_LAZY_TYPE,
        Memo = REACT_MEMO_TYPE,
        Portal = REACT_PORTAL_TYPE,
        Profiler = REACT_PROFILER_TYPE,
        StrictMode = REACT_STRICT_MODE_TYPE,
        Suspense = REACT_SUSPENSE_TYPE,
        hasWarnedAboutDeprecatedIsAsyncMode = !1;
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, exports.Element = Element, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment, exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.isAsyncMode = function (object) {
        return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }, exports.isConcurrentMode = isConcurrentMode, exports.isContextConsumer = function (object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }, exports.isContextProvider = function (object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }, exports.isElement = function (object) {
        return "object" === _typeof(object) && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
      }, exports.isForwardRef = function (object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }, exports.isFragment = function (object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }, exports.isLazy = function (object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }, exports.isMemo = function (object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }, exports.isPortal = function (object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }, exports.isProfiler = function (object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }, exports.isStrictMode = function (object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }, exports.isSuspense = function (object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }, exports.isValidElementType = function (type) {
        return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === _typeof(type) && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }, exports.typeOf = typeOf;
    }();
  }),
  reactIs = createCommonjsModule(function (module) {
    "production" === process.env.NODE_ENV ? module.exports = reactIs_production_min : module.exports = reactIs_development;
  }),
  getOwnPropertySymbols = Object.getOwnPropertySymbols,
  hasOwnProperty = Object.prototype.hasOwnProperty,
  propIsEnumerable = Object.prototype.propertyIsEnumerable;
var objectAssign = function () {
    try {
      if (!Object.assign) return !1;
      var test1 = new String("abc");
      if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
      for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if ("0123456789" !== order2.join("")) return !1;
      var test3 = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (letter) {
        test3[letter] = letter;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
    } catch (err) {
      return !1;
    }
  }() ? Object.assign : function (target, source) {
    for (var from, symbols, to = function (val) {
        if (null == val) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
      }(target), s = 1; s < arguments.length; s++) {
      for (var key in from = Object(arguments[s])) hasOwnProperty.call(from, key) && (to[key] = from[key]);
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
      }
    }
    return to;
  },
  has$2 = Function.call.bind(Object.prototype.hasOwnProperty),
  ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  has$1 = has$2,
  printWarning$1 = function () {};
if ("production" !== process.env.NODE_ENV) {
  var ReactPropTypesSecret = ReactPropTypesSecret$1,
    loggedTypeFailures = {},
    has = has$1;
  printWarning$1 = function (text) {
    var message = "Warning: " + text;
    "undefined" != typeof console && console.error(message);
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if ("production" !== process.env.NODE_ENV) for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
    var error;
    try {
      if ("function" != typeof typeSpecs[typeSpecName]) {
        var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _typeof(typeSpecs[typeSpecName]) + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
        throw err.name = "Invariant Violation", err;
      }
      error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
    } catch (ex) {
      error = ex;
    }
    if (!error || error instanceof Error || printWarning$1((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + _typeof(error) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), error instanceof Error && !(error.message in loggedTypeFailures)) {
      loggedTypeFailures[error.message] = !0;
      var stack = getStack ? getStack() : "";
      printWarning$1("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
    }
  }
}
checkPropTypes$1.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (loggedTypeFailures = {});
};
var checkPropTypes = checkPropTypes$1,
  printWarning = function () {};
function emptyFunctionThatReturnsNull() {
  return null;
}
"production" !== process.env.NODE_ENV && (printWarning = function (text) {
  var message = "Warning: " + text;
  "undefined" != typeof console && console.error(message);
  try {
    throw new Error(message);
  } catch (x) {}
});
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var require$$1 = function (isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator;
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createChainableTypeChecker(emptyFunctionThatReturnsNull),
      arrayOf: function (typeChecker) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          var propValue = props[propName];
          if (!Array.isArray(propValue)) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret$1);
            if (error instanceof Error) return error;
          }
          return null;
        });
      },
      element: createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        return isValidElement(propValue) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
      }),
      elementType: createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        return reactIs.isValidElementType(propValue) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
      }),
      instanceOf: function (expectedClass) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || "<<anonymous>>";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + (((propValue = props[propName]).constructor && propValue.constructor.name ? propValue.constructor.name : "<<anonymous>>") + "` supplied to `") + componentName + "`, expected instance of `" + expectedClassName + "`.");
          }
          var propValue;
          return null;
        });
      },
      node: createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
      }),
      objectOf: function (typeChecker) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          var propValue = props[propName],
            propType = getPropType(propValue);
          if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
          for (var key in propValue) if (has$1(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret$1);
            if (error instanceof Error) return error;
          }
          return null;
        });
      },
      oneOf: function (expectedValues) {
        if (!Array.isArray(expectedValues)) return "production" !== process.env.NODE_ENV && printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull;
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
          var valuesString = JSON.stringify(expectedValues, function (key, value) {
            return "symbol" === getPreciseType(value) ? String(value) : value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
        });
      },
      oneOfType: function (arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return "production" !== process.env.NODE_ENV && printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), emptyFunctionThatReturnsNull;
        }
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          for (var expectedTypes = [], i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checkerResult = (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
            if (null == checkerResult) return null;
            checkerResult.data && has$1(checkerResult.data, "expectedType") && expectedTypes.push(checkerResult.data.expectedType);
          }
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`" + (expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "") + ".");
        });
      },
      shape: function (shapeTypes) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          var propValue = props[propName],
            propType = getPropType(propValue);
          if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if ("function" != typeof checker) return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret$1);
            if (error) return error;
          }
          return null;
        });
      },
      exact: function (shapeTypes) {
        return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
          var propValue = props[propName],
            propType = getPropType(propValue);
          if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
          var allKeys = objectAssign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has$1(shapeTypes, key) && "function" != typeof checker) return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret$1);
            if (error) return error;
          }
          return null;
        });
      }
    };
    function is(x, y) {
      return x === y ? 0 !== x || 1 / x == 1 / y : x != x && y != y;
    }
    function PropTypeError(message, data) {
      this.message = message, this.data = data && "object" === _typeof(data) ? data : {}, this.stack = "";
    }
    function createChainableTypeChecker(validate) {
      if ("production" !== process.env.NODE_ENV) var manualPropTypeCallCache = {},
        manualPropTypeWarningCount = 0;
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        if (componentName = componentName || "<<anonymous>>", propFullName = propFullName || propName, secret !== ReactPropTypesSecret$1) {
          if (throwOnDirectAccess) {
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw err.name = "Invariant Violation", err;
          }
          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var cacheKey = componentName + ":" + propName;
            !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
          }
        }
        return null == props[propName] ? isRequired ? null === props[propName] ? new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`.") : new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
      }
      var chainedCheckType = checkType.bind(null, !1);
      return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      return createChainableTypeChecker(function (props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        return getPropType(propValue) !== expectedType ? new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.", {
          expectedType: expectedType
        }) : null;
      });
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function isNode(propValue) {
      switch (_typeof(propValue)) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) return propValue.every(isNode);
          if (null === propValue || isValidElement(propValue)) return !0;
          var iteratorFn = function (maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable["@@iterator"]);
            if ("function" == typeof iteratorFn) return iteratorFn;
          }(propValue);
          if (!iteratorFn) return !1;
          var step,
            iterator = iteratorFn.call(propValue);
          if (iteratorFn !== propValue.entries) {
            for (; !(step = iterator.next()).done;) if (!isNode(step.value)) return !1;
          } else for (; !(step = iterator.next()).done;) {
            var entry = step.value;
            if (entry && !isNode(entry[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function getPropType(propValue) {
      var propType = _typeof(propValue);
      return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : function (propType, propValue) {
        return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
      }(propType, propValue) ? "symbol" : propType;
    }
    function getPreciseType(propValue) {
      if (null == propValue) return "" + propValue;
      var propType = getPropType(propValue);
      if ("object" === propType) {
        if (propValue instanceof Date) return "date";
        if (propValue instanceof RegExp) return "regexp";
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
  },
  require$$2 = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret !== ReactPropTypesSecret$1) {
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw err.name = "Invariant Violation", err;
      }
    }
    function getShim() {
      return shim;
    }
    shim.isRequired = shim;
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    return ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
  },
  PropTypes = createCommonjsModule(function (module) {
    if ("production" !== process.env.NODE_ENV) {
      var ReactIs = reactIs;
      module.exports = require$$1(ReactIs.isElement, !0);
    } else module.exports = require$$2();
  });
var REACT_ELEMENT_TYPE;
function _jsx(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var Full = function (_ref) {
  return _jsx("svg", {
    className: _ref.className,
    width: _ref.width,
    height: _ref.height,
    viewBox: "0 0 41 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _jsx("path", {
    fill: _ref.color,
    fillRule: "nonzero",
    d: "M2.628 0h5.255L5.255 4.643h4.38L2.628 13l1.751-5.571H0L2.628 0zm11.589 9.533h-1.959l1.674-7.515H19.5l-.376 1.69h-3.61l-.25 1.172h3.519l-.376 1.69h-3.53l-.66 2.963zm9.468.136c-2.334 0-3.484-1.105-3.484-2.682 0-.124.034-.383.057-.496l1.002-4.473h1.992l-.99 4.428c-.012.057-.034.18-.034.316.011.62.49 1.217 1.457 1.217 1.048 0 1.583-.654 1.776-1.533l.991-4.428h1.981l-.99 4.462c-.41 1.825-1.412 3.189-3.758 3.189zm10.118-.136h-5.01l1.673-7.515h1.959l-1.287 5.825h3.04l-.375 1.69zm6.678 0h-5.01l1.674-7.515h1.959l-1.287 5.825h3.04l-.376 1.69z"
  }));
};
Full.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string
}, Full.defaultProps = {
  className: null,
  width: "41px",
  height: "13px",
  color: "rgba(0, 0, 0, 0.8)"
};
({
  className: PropTypes$1.string
});
var defaultProps = {
  className: null
};
var _path;
var Truck = function Truck(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_createRawReactElement("svg", {
    className: className,
    viewBox: "0 0 39 32"
  }, void 0, _path || (_path = /*#__PURE__*/_createRawReactElement("path", {
    d: "M21.7 24q.6-1.3 2-2t2.6-.8q1.5 0 2.7.7t2 2h4.4v-7.5L30 10.3h-4.8V6.8h5.6q.5 0 .8.2t.6.5l6.2 7.4q.3 0 .4.3t0 .6v9.6q0 .7-.5 1.2t-1 .4h-6q-.4 1.8-1.8 3t-3.2 1-3.3-1-1.7-3h-6q-.4 1.8-1.8 3t-3.2 1-3.3-1-1.7-3H1.7Q1 27.4.5 27T0 25.6V4q0-1.7 1.2-2.8T4 0h17.2q1.6 0 2.8 1.2T25.2 4v14.3h-3.5V4q0-.2-.2-.4t-.3-.2H4q-.3 0-.4.2t-.2.4v20h2.3q.6-1.3 2-2t2.6-.8q1.5 0 2.7.7t2 2h6.7zm4.6 4q.7 0 1.2-.5t.5-1.2-.5-1.2-1.2-.3-1.2.5-.3 1.3.5 1.2 1.3.5zm-16 0q.7 0 1.2-.5t.5-1.2-.5-1.2-1.2-.3T9 25t-.4 1.3.5 1.2 1.4.5z"
  })));
};
Truck.defaultProps = defaultProps;
var TruckGlyph = Truck;
var UiItemContext = /*#__PURE__*/createContext();
var UiItemContainer = function UiItemContainer(_ref) {
  var children = _ref.children,
    shippingTitle = _ref.shippingTitle,
    ftNewComponentsV2 = _ref.ftNewComponentsV2,
    shippingInfo = _ref.shippingInfo;
  var value = {
    shippingTitle: shippingTitle,
    ftNewComponentsV2: ftNewComponentsV2,
    shippingInfo: shippingInfo
  };
  return /*#__PURE__*/_createRawReactElement(UiItemContext.Provider, {
    value: value
  }, void 0, children);
};
UiItemContainer.defaultProps = {
  shippingTitle: '',
  ftNewComponentsV2: false
};
var UiItemContainer$1 = UiItemContainer;
var _TruckGlyph, _TruckGlyph2, _div3;
const Shipping = /*#__PURE__*/function () {
  const Shipping = function Shipping(_ref) {
    var _div, _div2;
    var shipping = _ref.shipping,
      _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === void 0 ? false : _ref$hidden;
    var _useContext = useContext(UiItemContext),
      shippingTitle = _useContext.shippingTitle,
      ftNewComponentsV2 = _useContext.ftNewComponentsV2,
      shippingInfo = _useContext.shippingInfo;
    var classNames$1 = classNames('ui-item__shipping', {
      'ui-item__shipping-free': shipping && shipping.freeShipping,
      'ui-item__shipping--hidden': hidden
    });
    var renderShipping = function renderShipping() {
      return _div || (_div = /*#__PURE__*/_createRawReactElement("div", {
        className: classNames$1,
        title: shippingTitle
      }, void 0, _TruckGlyph || (_TruckGlyph = /*#__PURE__*/_createRawReactElement(TruckGlyph, {
        className: "ui-item__shipping-icon"
      })), /*#__PURE__*/_createRawReactElement("span", {
        className: "ui-item__shipping-label"
      }, void 0, shippingTitle)));
    };
    var renderShippingWithFtV2 = function renderShippingWithFtV2() {
      return /*#__PURE__*/_createRawReactElement("div", {
        className: "ui-ms-shipping-container"
      }, void 0, _div2 || (_div2 = /*#__PURE__*/_createRawReactElement("div", {
        className: "ui-ms-shipping-container__item"
      }, void 0, /*#__PURE__*/_createRawReactElement("div", {
        className: classNames$1,
        title: shippingTitle
      }, void 0, _TruckGlyph2 || (_TruckGlyph2 = /*#__PURE__*/_createRawReactElement(TruckGlyph, {
        className: "ui-item__shipping-icon"
      })), /*#__PURE__*/_createRawReactElement("span", {
        className: "ui-item__shipping-label"
      }, void 0, shippingTitle)))), (shippingInfo === null || shippingInfo === void 0 ? void 0 : shippingInfo.fulfillment) && (_div3 || (_div3 = /*#__PURE__*/_createRawReactElement("div", {
        className: "ui-ms-shipping-container__item"
      }, void 0, /*#__PURE__*/_createRawReactElement(Full, {
        className: "ui-ms-shipping-fulfillment__icon"
      })))));
    };
    var renderShippingWithFtNewComponentsV2 = function renderShippingWithFtNewComponentsV2() {
      if (shipping && !ftNewComponentsV2) {
        return renderShipping();
      }
      if (shipping && ftNewComponentsV2) {
        return renderShippingWithFtV2();
      }
      return null;
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderShippingWithFtNewComponentsV2());
  };
  Shipping.defaultProps = {
    shipping: null,
    hidden: false
  };
  return Shipping;
}();
var Shipping$1 = Shipping;
var getFormattedPrice = function getFormattedPrice(_ref) {
  var currencySymbol = _ref.currencySymbol,
    value = _ref.value,
    cents = _ref.cents,
    decimalSeparator = _ref.decimalSeparator;
  return /*#__PURE__*/_createRawReactElement("span", {
    className: "ui-item__formatted-price"
  }, void 0, "".concat(currencySymbol, " ").concat(value), cents && /*#__PURE__*/React.createElement(React.Fragment, null, decimalSeparator, /*#__PURE__*/_createRawReactElement("span", {
    className: "ui-item__formatted-price-cents"
  }, void 0, cents)));
};
var getFormattedPrice$1 = getFormattedPrice;
var PriceBlockOriginal = function PriceBlockOriginal(_ref) {
  var locales = _ref.price.locales,
    installments = _ref.installments;
  return /*#__PURE__*/_createRawReactElement("div", {
    className: "ui-item__price-block"
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: "ui-item__price-container"
  }, void 0, (locales === null || locales === void 0 ? void 0 : locales.price) && /*#__PURE__*/_createRawReactElement("span", {
    className: "ui-item__price"
  }, void 0, getFormattedPrice$1({
    currencySymbol: locales.currency_symbol,
    value: locales.price,
    cents: locales.decimals,
    decimalSeparator: locales.decimal_separator
  })), (locales === null || locales === void 0 ? void 0 : locales.original_price) && /*#__PURE__*/_createRawReactElement("span", {
    className: "ui-item__original-price"
  }, void 0, getFormattedPrice$1({
    currencySymbol: locales.currency_symbol,
    value: locales.original_price
  }))), installments && /*#__PURE__*/_createRawReactElement("span", {
    className: "ui-item__installments"
  }, void 0, installments));
};
PriceBlockOriginal.defaultProps = {
  display: 'original',
  installments: null
};
var PriceBlock = PriceBlockOriginal;
var FALLBACK_WAITING_TIME_MS = 3000;
const Item$2 = /*#__PURE__*/function () {
  const Item = function Item(_ref) {
    var _globalConfig$card, _globalConfig$card2, _variationsData$;
    var actions = _ref.actions,
      attributes = _ref.attributes,
      condition = _ref.condition,
      className = _ref.className,
      showTitle = _ref.showTitle,
      id = _ref.id,
      image = _ref.image,
      imgSize = _ref.imgSize,
      installments = _ref.installments,
      lazyLoad = _ref.lazyLoad,
      price = _ref.price,
      shipping = _ref.shipping,
      title = _ref.title,
      titleRef = _ref.titleRef,
      url = _ref.url,
      discount = _ref.discount,
      withCardAction = _ref.with_card_action,
      cardAction = _ref.cart_info,
      _ref$cartItemQuantity = _ref.cartItemQuantity,
      cartItemQuantity = _ref$cartItemQuantity === void 0 ? 0 : _ref$cartItemQuantity,
      namespace = _ref.namespace,
      availableQuantity = _ref.available_quantity,
      maxAddToCartQuantity = _ref.max_add_to_cart_quantity,
      variationsQty = _ref.variations_qty,
      variationsData = _ref.variations_data,
      onClickCta = _ref.onClickCta,
      trackEvent = _ref.trackEvent,
      trackingData = _ref.trackingData,
      itemLink = _ref.permalink,
      relevant = _ref.relevant,
      updateItem = _ref.updateItem,
      addItem = _ref.addItem,
      deleteItem = _ref.deleteItem,
      saleTerms = _ref.sale_terms,
      _ref$product_cart_inf = _ref.product_cart_info,
      isCartEligible = _ref$product_cart_inf.is_cart_eligible,
      checkoutTargetMobile = _ref$product_cart_inf.checkout_target_mobile,
      checkoutTarget = _ref$product_cart_inf.checkout_target,
      deviceType = _ref.deviceType,
      _ref$onlyWebCheckout = _ref.onlyWebCheckout,
      onlyWebCheckout = _ref$onlyWebCheckout === void 0 ? false : _ref$onlyWebCheckout,
      globalConfig = _ref.globalConfig;
    var _ref2 = saleTerms || {},
      purchaseMinQuantity = _ref2.purchase_min_quantity,
      purchaseMaxQuantity = _ref2.purchase_max_quantity;
    var Element = url ? 'a' : 'div';
    var itemNamespace = 'ui-item__content';
    var itemClassNames = classNames('ui-item', _defineProperty({}, "".concat(className), className));
    var itemContent = classNames(itemNamespace, _defineProperty(_defineProperty({}, "".concat(itemNamespace, "--with-original-price"), price === null || price === void 0 ? void 0 : price.original_price), "".concat(itemNamespace, "--").concat(globalConfig === null || globalConfig === void 0 || (_globalConfig$card = globalConfig.card) === null || _globalConfig$card === void 0 ? void 0 : _globalConfig$card.design), globalConfig === null || globalConfig === void 0 || (_globalConfig$card2 = globalConfig.card) === null || _globalConfig$card2 === void 0 ? void 0 : _globalConfig$card2.design));
    var variation = (variationsData === null || variationsData === void 0 ? void 0 : variationsData.length) > 0 ? (_variationsData$ = variationsData[0]) === null || _variationsData$ === void 0 ? void 0 : _variationsData$.id : '';
    var _useState = useState(cartItemQuantity),
      _useState2 = _slicedToArray(_useState, 2),
      itemQuantity = _useState2[0],
      setItemQuantity = _useState2[1];
    var _useState3 = useState(cartItemQuantity ? 'update' : 'add'),
      _useState4 = _slicedToArray(_useState3, 2),
      updateAction = _useState4[0],
      setUpdateAction = _useState4[1];
    var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      quantityUpdateId = _useState6[0],
      setQuantityUpdateId = _useState6[1];
    var hasMoreVariations = variationsQty && variationsQty > 1;
    var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      initialValue = _useState8[0],
      setInitial = _useState8[1];
    var addToCart = function addToCart(minQuantity) {
      if (cartItemQuantity > 0) {
        setUpdateAction('update');
      } else {
        setUpdateAction('add');
      }
      setItemQuantity(minQuantity);
    };
    var handleCtaClick = function handleCtaClick(event, redirectTo, doNotTrack) {
      event.stopPropagation();
      if (onClickCta) {
        onClickCta();
      } else if (redirectTo) {
        if (trackEvent && trackingData && !doNotTrack) {
          trackEvent(trackingData);
        }
        window.location = redirectTo;
      }
    };
    var shouldAddToCart = function shouldAddToCart(event) {
      event.preventDefault();
      if (hasMoreVariations || relevant) {
        handleCtaClick(event, itemLink);
      } else if (!isCartEligible) {
        if (onlyWebCheckout) {
          return handleCtaClick(event, checkoutTarget);
        }
        handleCtaClick(event, checkoutTargetMobile);
        if (checkoutTargetMobile !== checkoutTarget) {
          setTimeout(function () {
            handleCtaClick(event, checkoutTarget, true);
          }, FALLBACK_WAITING_TIME_MS);
        }
      } else {
        if (trackEvent && trackingData) {
          trackEvent(trackingData);
        }
        addToCart(purchaseMinQuantity !== null && purchaseMinQuantity !== void 0 ? purchaseMinQuantity : 1);
      }
    };
    var handleQuantityIncrement = function handleQuantityIncrement() {
      var newQuantity = itemQuantity + 1;
      return setItemQuantity(newQuantity);
    };
    var handleQuantityDecrement = function handleQuantityDecrement() {
      var newQuantity = itemQuantity - 1;
      if (newQuantity === 0 || purchaseMinQuantity && newQuantity < purchaseMinQuantity) {
        setUpdateAction('delete');
        return setItemQuantity(0);
      }
      setUpdateAction('update');
      return setItemQuantity(newQuantity);
    };
    var getMaxPurchaseQuantity = function getMaxPurchaseQuantity() {
      var maxAvailable = maxAddToCartQuantity || availableQuantity;
      return purchaseMaxQuantity !== null && purchaseMaxQuantity <= maxAvailable ? purchaseMaxQuantity : maxAvailable;
    };
    useEffect(function () {
      if (initialValue) {
        setInitial(false);
        return;
      }
      if (quantityUpdateId !== null) {
        clearTimeout(quantityUpdateId);
      }
      var timeoutId = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee() {
        var cartPromise, success;
        return regenerator.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cartPromise = updateAction === 'update' ? updateItem : addItem;
              if (!(itemQuantity === 0)) {
                _context.next = 2;
                break;
              }
              if (!(updateAction === 'add')) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              cartPromise = deleteItem;
            case 2:
              _context.next = 3;
              return cartPromise(id, itemQuantity, variation);
            case 3:
              success = _context.sent;
              if (!success) {
                setInitial(true);
                setItemQuantity(cartItemQuantity || 0);
              }
              setUpdateAction(itemQuantity > 0 ? 'update' : 'add');
              clearTimeout(quantityUpdateId);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), 700);
      setQuantityUpdateId(timeoutId);
    }, [itemQuantity]);
    return /*#__PURE__*/_createRawReactElement(Element, {
      href: url,
      className: itemClassNames,
      itemScope: true,
      itemType: "http://schema.org/Product",
      title: showTitle ? title : null
    }, void 0, discount && /*#__PURE__*/_createRawReactElement(PromotionTag, {
      primaryLabel: discount.primary_label,
      secondaryLabel: discount.secondary_label
    }), /*#__PURE__*/React.createElement(Image$1, _extends({}, image, {
      size: imgSize,
      title: title,
      lazyLoad: lazyLoad
    })), /*#__PURE__*/_createRawReactElement("div", {
      className: itemContent
    }, void 0, (price || installments) && /*#__PURE__*/_createRawReactElement(PriceBlock, {
      price: price,
      installments: installments
    }), attributes && /*#__PURE__*/_createRawReactElement("span", {
      className: "ui-item__attributes"
    }, void 0, attributes), title && /*#__PURE__*/React.createElement("p", {
      className: "ui-item__title",
      itemProp: "name",
      ref: titleRef
    }, title), actions.map(function (action) {
      return /*#__PURE__*/React.createElement(Action, _extends({
        key: action.id
      }, action));
    }), /*#__PURE__*/_createRawReactElement(Shipping$1, {
      shipping: shipping
    }), withCardAction && /*#__PURE__*/_createRawReactElement("div", {
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      className: "".concat(namespace, "__card-action")
    }, void 0, /*#__PURE__*/React.createElement(CardAction, _extends({
      layout: "column",
      onAddToCart: shouldAddToCart,
      itemQuantity: itemQuantity,
      purchaseMaxQuantity: getMaxPurchaseQuantity(),
      incrementQuantity: handleQuantityIncrement,
      decrementQuantity: handleQuantityDecrement,
      hasMoreVariations: hasMoreVariations,
      isCartEligible: isCartEligible,
      deviceType: deviceType
    }, cardAction)))), url && /*#__PURE__*/_createRawReactElement("meta", {
      itemProp: "url",
      content: url
    }), condition && /*#__PURE__*/_createRawReactElement("meta", {
      itemProp: "itemCondition",
      content: condition
    }), id && /*#__PURE__*/_createRawReactElement("meta", {
      itemProp: "productID",
      content: id
    }));
  };
  Item.defaultProps = defaultProps$1;
  return Item;
}();
var Item$3 = Item$2;
const ItemWrapper = /*#__PURE__*/function () {
  const ItemWrapper = function ItemWrapper(props) {
    var shippingTitle = props.shippingTitle,
      ftNewComponentsV2 = props.ftNewComponentsV2,
      shippingInfo = props.shippingInfo;
    return /*#__PURE__*/_createRawReactElement(UiItemContainer$1, {
      shippingTitle: shippingTitle,
      ftNewComponentsV2: ftNewComponentsV2,
      shippingInfo: shippingInfo
    }, void 0, /*#__PURE__*/React.createElement(Item$3, props));
  };
  ItemWrapper.defaultProps = defaultProps$1;
  return ItemWrapper;
}();
var MeliItem = ItemWrapper;
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof$1(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var REGEX = /\B(?=(\d{3})+(?!\d))/g;
var FormatPriceService = /*#__PURE__*/function () {
  function FormatPriceService() {
    _classCallCheck(this, FormatPriceService);
  }
  return _createClass(FormatPriceService, null, [{
    key: "getDecimalPart",
    value: function getDecimalPart(price, decimalPlaces) {
      var decimalPart = Math.floor((price - Math.floor(price)) * Math.pow(10, decimalPlaces));
      var decimalString = '';
      if (decimalPart) {
        decimalString = decimalPart.toString();
      }
      return decimalString;
    }
  }, {
    key: "getFormattedFraction",
    value: function getFormattedFraction(price) {
      return Math.floor(price).toString();
    }
  }, {
    key: "getShipping",
    value: function getShipping(_ref) {
      var freeShipping = _ref.free_shipping,
        text = _ref.label;
      if (!freeShipping || !text) {
        return null;
      }
      return {
        freeShipping: freeShipping,
        text: text
      };
    }
  }, {
    key: "getThousandSeparated",
    value: function getThousandSeparated(_ref2) {
      var price = _ref2.price,
        separator = _ref2.separator;
      var fraction = this.getFormattedFraction(price);
      return fraction.replace(REGEX, separator);
    }
  }, {
    key: "getPriceDigits",
    value: function getPriceDigits(price) {
      return Math.floor(price.value).toString().length;
    }
  }]);
}();
var FormatPriceService$1 = FormatPriceService;
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
var updateMappedProps = function updateMappedProps(props) {
  var price = props.price,
    itemsPerRow = props.itemsPerRow,
    display = props.display,
    isTrigger = props.is_trigger,
    actions = props.actions,
    installments = props.installments,
    attributes = props.attributes,
    picture = props.picture,
    shipping = props.shipping,
    permalink = props.permalink,
    purchase_discount = props.purchase_discount,
    discountLabel = props.discount_label,
    discount = props.discount,
    _props$globalConfig = props.globalConfig,
    globalConfig = _props$globalConfig === void 0 ? {
      card: {
        design: 'left-aligned'
      }
    } : _props$globalConfig,
    deviceType = props.deviceType;
  var formattedDiscount = function formattedDiscount(label, purchaseDiscount, productDiscount) {
    return {
      primary_label: (productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.primary_label) || label,
      secondary_label: productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.secondary_label,
      discount_type: purchaseDiscount === null || purchaseDiscount === void 0 ? void 0 : purchaseDiscount.discount_type
    };
  };
  var priceDigits = FormatPriceService$1.getPriceDigits(price);
  var className = classNames(props.className, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "items-per-row-".concat(itemsPerRow), itemsPerRow), "".concat(display), display), "price-digits-".concat(priceDigits), purchase_discount), 'price-text', price.text), 'trigger-item', isTrigger), 'with-actions', actions.length), 'with-discount', purchase_discount), 'with-installments', installments), 'with-attributes', attributes));
  return _objectSpread2(_objectSpread2({}, props), {}, {
    className: className,
    image: picture,
    installments: installments,
    price: price,
    discount: discountLabel || purchase_discount || discount ? _objectSpread2({}, formattedDiscount(discountLabel, purchase_discount, discount)) : null,
    shipping: shipping && FormatPriceService$1.getShipping(shipping),
    url: permalink,
    globalConfig: globalConfig,
    deviceType: deviceType
  });
};
function withItemBehavior(WrappedComponent) {
  var WithItemBehavior = /*#__PURE__*/function (_React$Component) {
    function WithItemBehavior(props) {
      var _this;
      _classCallCheck(this, WithItemBehavior);
      _this = _callSuper(this, WithItemBehavior, [props]);
      _this.itemHover = _this.itemHover.bind(_this);
      _this.isFetching = false;
      _this.state = {
        singleLineTitleClassName: '',
        mappedProps: updateMappedProps(props)
      };
      return _this;
    }
    _inherits(WithItemBehavior, _React$Component);
    return _createClass(WithItemBehavior, [{
      key: "itemHover",
      value: function itemHover() {
        if (this.title) {
          var itemDescriptionHeight = this.title.clientHeight;
          this.isSingleLineDescription(itemDescriptionHeight);
        }
      }
    }, {
      key: "isSingleLineDescription",
      value: function isSingleLineDescription(height) {
        if (height <= 18) {
          this.setState({
            singleLineTitleClassName: 'with-single-line-description'
          });
        }
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var mappedProps = updateMappedProps(nextProps);
        this.setState({
          mappedProps: mappedProps
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _mappedProps$globalCo,
          _mappedProps$globalCo2,
          _this2 = this;
        var _this$state = this.state,
          mappedProps = _this$state.mappedProps,
          singleLineTitleClassName = _this$state.singleLineTitleClassName;
        var className = classNames(mappedProps.className, singleLineTitleClassName);
        var wrapperClassNames = className && className.split(/\s+/).map(function (name) {
          return "".concat(name, "__wrapper");
        });
        return /*#__PURE__*/_createRawReactElement("div", {
          className: classNames("ui-item__wrapper", wrapperClassNames, _defineProperty(_defineProperty({}, "ui-item__wrapper--".concat(mappedProps === null || mappedProps === void 0 || (_mappedProps$globalCo = mappedProps.globalConfig) === null || _mappedProps$globalCo === void 0 || (_mappedProps$globalCo = _mappedProps$globalCo.card) === null || _mappedProps$globalCo === void 0 ? void 0 : _mappedProps$globalCo.design), mappedProps === null || mappedProps === void 0 || (_mappedProps$globalCo2 = mappedProps.globalConfig) === null || _mappedProps$globalCo2 === void 0 || (_mappedProps$globalCo2 = _mappedProps$globalCo2.card) === null || _mappedProps$globalCo2 === void 0 ? void 0 : _mappedProps$globalCo2.design), "ui-item__wrapper--".concat(mappedProps === null || mappedProps === void 0 ? void 0 : mappedProps.deviceType), mappedProps === null || mappedProps === void 0 ? void 0 : mappedProps.deviceType)),
          onFocus: this.itemHover,
          onMouseOver: this.itemHover
        }, void 0, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, mappedProps, {
          className: className,
          titleRef: function titleRef(title) {
            _this2.title = title;
          }
        })));
      }
    }]);
  }(React.Component);
  WithItemBehavior.itemPropTypes = {
    actions: PropTypes$1.array,
    bookmarked: PropTypes$1.bool,
    className: PropTypes$1.string,
    display: PropTypes$1.string,
    id: PropTypes$1.string.isRequired,
    is_trigger: PropTypes$1.bool,
    permalink: PropTypes$1.string.isRequired,
    picture: PropTypes$1.shape({
      title: PropTypes$1.string,
      src: PropTypes$1.string,
      src2x: PropTypes$1.string,
      width: PropTypes$1.string,
      height: PropTypes$1.string,
      className: PropTypes$1.string
    }).isRequired,
    price: PropTypes$1.shape({
      currency_id: PropTypes$1.string,
      currency_symbol: PropTypes$1.string,
      text: PropTypes$1.string,
      value: PropTypes$1.number
    }).isRequired,
    shipping: PropTypes$1.shape({
      free_shipping: PropTypes$1.bool,
      label: PropTypes$1.string
    }),
    squared: PropTypes$1.bool
  };
  WithItemBehavior.defaultProps = {
    actions: [],
    bookmarked: false,
    className: '',
    currency_id: null,
    currency_symbol: null,
    display: 'original',
    price: null,
    price_text: null,
    is_trigger: false,
    shipping: null,
    squared: false
  };
  var exportItem = WithItemBehavior;
  return exportItem;
}
var desktop = withItemBehavior(MeliItem);
var ItemImage = function ItemImage(_ref) {
  var lazyLoad = _ref.lazyLoad,
    src = _ref.src,
    size = _ref.size,
    src2x = _ref.src2x,
    title = _ref.title;
  var srcSet = src2x ? "".concat(src, " 1x, ").concat(src2x, " 2x") : null;
  return /*#__PURE__*/_createRawReactElement("div", {
    className: "ui-item__image-container"
  }, void 0, /*#__PURE__*/_createRawReactElement("meta", {
    itemProp: "image",
    content: src
  }), /*#__PURE__*/_createRawReactElement(Image$2, {
    src: src,
    lazyload: lazyLoad,
    width: size,
    height: size,
    alt: title,
    srcSet: srcSet,
    "data-testid": "image",
    className: "ui-item__image"
  }));
};
ItemImage.defaultProps = {
  size: null,
  src2x: null,
  title: null,
  lazyLoad: 'on'
};
var Image = ItemImage;
const Item = /*#__PURE__*/function () {
  const Item = function Item(_ref) {
    var actions = _ref.actions,
      attributes = _ref.attributes,
      condition = _ref.condition,
      className = _ref.className,
      showTitle = _ref.showTitle,
      id = _ref.id,
      image = _ref.image,
      imgSize = _ref.imgSize,
      installments = _ref.installments,
      isFirstPage = _ref.isFirstPage,
      lazyLoad = _ref.lazyLoad,
      price = _ref.price,
      shipping = _ref.shipping,
      title = _ref.title,
      titleRef = _ref.titleRef,
      url = _ref.url,
      discount = _ref.discount,
      withCardAction = _ref.with_card_action,
      cardAction = _ref.card_action,
      namespace = _ref.namespace,
      isCartEligible = _ref.product_cart_info.is_cart_eligible;
    var Element = url ? 'a' : 'div';
    var discountBoxClasses = classNames('ui-item__discount-box', {
      'ui-item__discount-box--short-text': !(discount !== null && discount !== void 0 && discount.secondary_label)
    });
    var discountBoxTextClasses = classNames('ui-item__discount-text');
    var discountBoxTextSecondaryClasses = classNames('ui-item__discount-text', {
      'ui-item__discount-text--secondary': Boolean(discount === null || discount === void 0 ? void 0 : discount.secondary_label)
    });
    var itemClassNames = classNames('ui-item', _defineProperty({}, "".concat(className), className));
    var itemContent = classNames('ui-item__content', {
      'ui-item__content--with-original-price': price === null || price === void 0 ? void 0 : price.original_price
    });
    return /*#__PURE__*/_createRawReactElement(Element, {
      href: url,
      className: itemClassNames,
      itemScope: true,
      itemType: "http://schema.org/Product",
      title: showTitle ? title : null
    }, void 0, discount && /*#__PURE__*/_createRawReactElement("div", {
      className: discountBoxClasses
    }, void 0, /*#__PURE__*/_createRawReactElement("span", {
      className: discountBoxTextClasses
    }, void 0, discount.primary_label), (discount === null || discount === void 0 ? void 0 : discount.secondary_label) && /*#__PURE__*/_createRawReactElement("span", {
      className: discountBoxTextSecondaryClasses
    }, void 0, discount.secondary_label)), /*#__PURE__*/React.createElement(Image, _extends({
      isFirstPage: isFirstPage
    }, image, {
      size: imgSize,
      title: title,
      lazyLoad: lazyLoad
    })), /*#__PURE__*/_createRawReactElement("div", {
      className: itemContent
    }, void 0, (price || installments) && /*#__PURE__*/_createRawReactElement(PriceBlock, {
      price: price,
      installments: installments
    }), attributes && /*#__PURE__*/_createRawReactElement("span", {
      className: "ui-item__attributes"
    }, void 0, attributes), title && /*#__PURE__*/React.createElement("p", {
      className: "ui-item__title",
      itemProp: "name",
      ref: titleRef
    }, title), actions.map(function (action) {
      return /*#__PURE__*/React.createElement(Action, _extends({
        key: action.id
      }, action));
    }), /*#__PURE__*/_createRawReactElement(Shipping$1, {
      shipping: shipping
    })), url && /*#__PURE__*/_createRawReactElement("meta", {
      itemProp: "url",
      content: url
    }), condition && /*#__PURE__*/_createRawReactElement("meta", {
      itemProp: "itemCondition",
      content: condition
    }), id && /*#__PURE__*/_createRawReactElement("meta", {
      itemProp: "productID",
      content: id
    }), withCardAction && /*#__PURE__*/_createRawReactElement("div", {
      className: "".concat(namespace, "__card-action")
    }, void 0, /*#__PURE__*/React.createElement(CardAction, _extends({
      isCartEligible: isCartEligible
    }, cardAction))));
  };
  Item.defaultProps = defaultProps$1;
  return Item;
}();
var Item$1 = Item;
const VariationItem = /*#__PURE__*/function () {
  const VariationItem = function VariationItem(props) {
    var shippingTitle = props.shippingTitle,
      ftNewComponentsV2 = props.ftNewComponentsV2,
      shippingInfo = props.shippingInfo;
    return /*#__PURE__*/_createRawReactElement(UiItemContainer$1, {
      shippingTitle: shippingTitle,
      ftNewComponentsV2: ftNewComponentsV2,
      shippingInfo: shippingInfo
    }, void 0, /*#__PURE__*/React.createElement(Item$1, props));
  };
  VariationItem.defaultProps = defaultProps$1;
  return VariationItem;
}();
var ItemMobile = VariationItem;
var mobile = withItemBehavior(ItemMobile);
export { desktop as ItemDesktop, mobile as ItemMobile };
